export default __webpack_public_path__ + "static/media/discord_white.d01759ff.svg";